import React from "react";

const Lsi = {

  blockEditableLabelIcon: {
    cs: "Ikona",
    en: "Icon"
  },

  blockEditableLabelText: {
    cs: "Text",
    en: "Text"
  },

  blockEditableIconPlaceholder: {
    cs: "Ponechte prázdné pro výchozí ikonu",
    en: "Leave blank for default icon"
  },

};

export default Lsi;



// WEBPACK FOOTER //
// ./config/lsi.js